module.exports = __webpack_public_path__ + "img/NZA Annex D - Solar and wind generation.pdf";